import React from 'react';
import './App.scss';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import Home from './components/application/Home';
import {useDispatch, useSelector} from 'react-redux';
import {setUser, removeUser, getUser} from './app/redux/userSlice';
import {useEffect} from 'react';
import db, {auth, cCustomers} from './firebase';
import {useState} from 'react';
import Snackbar from './components/application/Snackbar';
import {
  accountPath,
  authScreens,
  Footer,
  Header,
  protectedScreens,
  publicScreens,
  signinPath,
} from './utils/CompEXP';
import {Suspense} from 'react';
import Loader from './components/application/Loader';
import {addFav} from './app/redux/favSlice';
import {addCart, cleanCart} from './app/redux/cartSlice';
import CryptoJS from 'crypto-js';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import moment from 'moment';
import {setAdmin} from './app/redux/adminSlice';

const promise = loadStripe(
  'pk_live_51HY52WFjZQ7CZLyyoUsPqTcbX1TVO0H5r2HeuLtQfJAGZ8iFKn0HT9sVjSHoS94KAYucDNAOxXMQQWp3i5uZopP300trFNahOL'
);

function App() {
  const user = useSelector(getUser);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    if (loader) {
      const interval = setInterval(() => {
        setLoader(false);
      }, 1200);
      return () => clearInterval(interval);
    }
  }, [loader]);

  const [offline, setOffline] = useState(false);

  useEffect(() => {
    window.addEventListener('offline', () => setOffline(true));
    window.addEventListener('online', () => setOffline(false));
    return () => {
      window.removeEventListener('offline');
      window.removeEventListener('online');
    };
  }, []);

  useEffect(() => {
    auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        setLoader(true);
        if (!offline) {
          db.collection(cCustomers)
            .doc(authUser?.uid)
            .onSnapshot((snap) => {
              dispatch(
                setUser({
                  addrPrimary: snap.data()?.addrPrimary,
                  addrSecondary: snap.data()?.addrSecondary,
                  dob: snap.data()?.dob,
                  email: authUser.email,
                  name: snap.data()?.name,
                  phone: snap.data()?.phone,
                  photo: snap.data()?.photo,
                  uid: authUser.uid,
                  uno: snap.data()?.uno,
                  stripeID: snap.data()?.stripeID,
                  created: moment(snap.data()?.timestamp.toDate()).format(
                    'YYYY-MM-DD'
                  ),
                })
              );
            });
          db.collection(cCustomers)
            .doc(authUser.uid)
            .collection('fav')
            .orderBy('timestamp', 'asc')
            .get()
            .then((snap) => {
              snap.docs.map((doc) =>
                dispatch(
                  addFav({
                    id: doc.data().id,
                    category: doc.data().category,
                    product: doc.data().product,
                  })
                )
              );
            });
          const admins = process.env.REACT_APP_BM_ADMINS.split(',');
          for (let i = 0; i < admins.length; i++) {
            if (admins[i].match(authUser.uid)) {
              dispatch(setAdmin());
              break;
            }
          }
        }
      } else {
        dispatch(removeUser());
      }

      const localCart = localStorage.getItem(
        authUser ? authUser.uid : 'jFbVuVhocc'
      );

      if (localCart !== null) {
        dispatch(cleanCart({user: authUser ? authUser.uid : 'jFbVuVhocc'}));
        const bytes = CryptoJS.AES.decrypt(
          localCart.slice(1, -1),
          process.env.REACT_APP_CART_KEY
        );
        const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        decryptedData['cart'].map((c) =>
          dispatch(
            addCart({user: authUser ? authUser.uid : 'jFbVuVhocc', data: c})
          )
        );
      }
    });
  }, [dispatch, offline]);

  return (
    <div className="app">
      {loader ? (
        <Loader />
      ) : (
        <Router>
          {!offline ? (
            <Suspense fallback={<Loader />}>
              <Header />
              <Snackbar />
              <Switch>
                {publicScreens.map((screen, i) => {
                  return (
                    <Route
                      exact
                      path={screen.path}
                      key={i}
                      render={({match}) => <screen.view />}
                    />
                  );
                })}
                {protectedScreens.map((screen, i) => {
                  return (
                    <Route
                      exact
                      path={screen.path}
                      key={i}
                      render={({match}) =>
                        user ? (
                          <>
                            {screen.path === '/checkout' ? (
                              <Elements stripe={promise}>
                                <screen.view />
                              </Elements>
                            ) : (
                              <screen.view />
                            )}
                          </>
                        ) : screen.path === '/checkout' ? (
                          <Redirect to="/cart" />
                        ) : (
                          <Redirect to={signinPath} />
                        )
                      }
                    />
                  );
                })}
                {authScreens.map((screen, i) => {
                  return (
                    <Route
                      exact
                      path={screen.path}
                      key={i}
                      render={({match}) =>
                        !user ? <screen.view /> : <Redirect to={accountPath} />
                      }
                    />
                  );
                })}
                <Route path="/">
                  <Home />
                </Route>
              </Switch>
              <Footer />
            </Suspense>
          ) : (
            <div
              style={{
                backgroundColor: 'white',
                color: '#505050',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                width: '100vw',
              }}
            >
              <h1 style={{letterSpacing: '1px', marginBottom: '1rem'}}>
                ☹ You're offline‼
              </h1>
              <h3 style={{lineHeight: '25px', textAlign: 'center'}}>
                Please connect back to the internet
                <br />& try again.
              </h3>
            </div>
          )}
        </Router>
      )}
    </div>
  );
}

export default App;
